// removed by extract-text-webpack-plugin
module.exports = {"mobile":"mobile___TXFju","mobileInner":"mobileInner___25A-F","header":"header___1zWCZ","headerMobile":"headerMobile___1a1pk","headerDesktop":"headerDesktop___2he0R","links":"links___ILqiS","app-store-link":"app-store-link___2pUdz","ios":"ios___YkhZH","android":"android___giMRq"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Footer/WhiteLabelFooter/Mobile/Mobile.scss
// module id = 9T3g
// module chunks = 57